import React from 'react';
import c from '../w.js';

const IconGraphBar = React.memo(
  c(
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M18.5 5H15.5V19H18.5V5Z" }), /* @__PURE__ */ React.createElement("path", { d: "M10.5 9H13.5V19H10.5V9Z" }), /* @__PURE__ */ React.createElement("path", { d: "M5.5 13H8.5V19H5.5V13Z" }))
  )
);

export { IconGraphBar };
